import { render, staticRenderFns } from "./openHall.vue?vue&type=template&id=431ed68a&scoped=true"
import script from "./openHall.vue?vue&type=script&lang=js"
export * from "./openHall.vue?vue&type=script&lang=js"
import style0 from "./openHall.vue?vue&type=style&index=0&id=431ed68a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431ed68a",
  null
  
)

export default component.exports